export default __webpack_public_path__ + "static/media/ndalex.44774caa.jpg";